import { applyMiddleware, compose, createStore, Store } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { RootAction, RootState } from 'typesafe-actions';

import { signalrMiddleware } from 'services/signalR.middleware';
import signalRFilterMiddleware from 'services/signalr-filter.middleware';

import { rootEpic } from './root.epics';
import rootReducer from './rootReducer';
import { getInitialState } from './store.initialState';

const epicMiddleware = createEpicMiddleware<RootAction, RootAction, RootState>({
  dependencies: { api: {} },
});

const composeEnhancers =
  (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const createStoreWithMiddleware = composeEnhancers(
  applyMiddleware(epicMiddleware, signalrMiddleware, signalRFilterMiddleware),
)(createStore);

export default function configureStore() {
  // @ts-ignore
  const store: Store<RootState, RootAction> = createStoreWithMiddleware(
    // @ts-ignores
    enableBatching(rootReducer),
    getInitialState(),
  );
  epicMiddleware.run(combineEpics(rootEpic));
  return { store };
}
